// extracted by mini-css-extract-plugin
export default {"widget":"RiskMetricsWidget_widget__OObz5","card":"RiskMetricsWidget_card__24H2a"};